module.exports = __webpack_public_path__ + "static/media/lumbering13.5cae70df.jpg";